import * as Yup from 'yup';

import { useResolvableServiceValueSchema } from './useResolvableServiceValueSchema.hook';

export const useResolvableServiceSchema = () => {
  const ResolvableServiceValueSchema = useResolvableServiceValueSchema();

  const ResolvableServiceSchema = Yup.object().shape({
    codingConfig: Yup.object()
      .shape({
        code: Yup.string().required('Code requis'),
      })
      .required('Code requis'),
    label: Yup.string().required('Libellé requis'),
    title: Yup.string().optional().nullable().default(undefined),
    content: Yup.string().optional().nullable().default(undefined),
    value: ResolvableServiceValueSchema.required('Valeur requise'),
    materialUsages: Yup.array().of(
      Yup.object()
        .shape({
          materialId: Yup.string().required('Matériel requis'),
          quantity: Yup.object().shape({
            value: Yup.number()
              .required('Quantité requise')
              .moreThan(0, 'La quantité doit être supérieure à 0'),
            unitId: Yup.string().required('Unité requise'),
          }),
        })
        .required('Matériel requis'),
    ),
    costUsages: Yup.array().of(
      Yup.object()
        .shape({
          costId: Yup.string().required('Coût requis'),
          quantity: Yup.object().shape({
            value: Yup.number()
              .required('Quantité requise')
              .moreThan(0, 'La quantité doit être supérieure à 0'),
            unitId: Yup.string().required('Unité requise'),
          }),
        })
        .required('Coût requis'),
    ),
  });

  return ResolvableServiceSchema;
};
